/** Detect Windows Package Manager (winget) from installed-software snapshots. */

function normalisePrograms(payload) {
  if (!payload || typeof payload !== 'object') return []
  const programs = payload.programs
  if (!Array.isArray(programs)) return []
  return programs.filter((row) => row && typeof row === 'object')
}

export function isWingetProgram(name, publisher = null) {
  const lower = String(name ?? '').trim().toLowerCase()
  if (!lower) return false
  if (lower.includes('windows package manager')) return true
  if (lower.includes('desktopappinstaller')) return true
  if (lower.includes('app installer')) {
    const pub = String(publisher ?? '').trim().toLowerCase()
    return !pub || pub.includes('microsoft')
  }
  return false
}

/**
 * @returns {{ hasData: boolean, installed: boolean, matches: Array<{ name, version, publisher, install_date }> }}
 */
export function detectWingetFromPayload(payload) {
  const programs = normalisePrograms(payload)
  const hasProgramsKey = payload && typeof payload === 'object' && 'programs' in payload
  const hasData = programs.length > 0 || hasProgramsKey

  if (!hasData) {
    return { hasData: false, installed: false, matches: [] }
  }

  const matches = []
  for (const row of programs) {
    const name = row.name ?? row.Name ?? null
    const publisher = row.publisher ?? row.Publisher ?? null
    if (!isWingetProgram(name, publisher)) continue
    const version = row.version ?? row.Version ?? null
    matches.push({
      name: name != null ? String(name).trim() : null,
      version: version != null ? String(version).trim() : null,
      publisher: publisher != null ? String(publisher).trim() : null,
      install_date: row.install_date ?? row.InstallDate ?? null,
    })
  }

  return {
    hasData: true,
    installed: matches.length > 0,
    matches,
  }
}

export function wingetMatchSummary(matches, maxItems = 2) {
  if (!matches?.length) return null
  const parts = matches.slice(0, maxItems).map((row) => {
    const name = (row.name || 'Unknown').trim()
    const version = (row.version || '').trim()
    return version ? `${name} (${version})` : name
  })
  let text = parts.join('; ')
  if (matches.length > maxItems) {
    text += ` (+${matches.length - maxItems} more)`
  }
  return text
}
